<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<app-breadcrumb></app-breadcrumb>
<div class="row" style="margin-bottom: 5px;">


  <div class="d-flex gap-3 col-md-12 justify-content-end">
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openExcelPdfReportPopup('Pdf','3')" (keydown.enter)="openExcelPdfReportPopup('Pdf','3')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="back()">
      Cancel
    </button>
    <div class=" float-right d-flex gap-2 action-buttons-container">
      <div *ngFor="let button of buttonLabels"
        class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="dynamicButtonClick(button)" (keydown.enter)="dynamicButtonClick(button)">
        <span class="reload_text text-white">{{button}}</span>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="instructions !=null">
    <p style="text-align: right;margin-bottom:0px;"><i>{{instructions}}</i></p>
  </div>
</div>
<div class="menu-container">
  <div class="row menu-row-container">
    <div class="col-sm-6 gridName-container">
      <span class="gridName">Training Details
      </span>
    </div>
  </div>
  <hr>
</div>
<div class="table-container">
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <div id="serach-field-container" *ngIf="dynamicLabel">
    <div class="row">
      <div class="col-md-2">
        <!-- Training -->
        <div><label for="email">{{dynamicLabel['TRAINING_NAME']}}</label><span class="mandatory-symbol">*</span></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="scheduleTrainingFieldData.trainingName" disabled>
      </div>
      <div class="col-md-2">
        <!-- Version -->
        <div><label for="email">{{dynamicLabel['VERSION']}}</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="scheduleTrainingFieldData.version" disabled>
      </div>

      <div class="col-md-2 search-container">
        <div>
          <label for="email ">{{dynamicLabel['TRAINER_NAME']}}</label>
          <label for="evaluator-switch" *ngIf="this.message.showSwitchUser && canShowTrainerSwitchUser()">
            <a (click)="searchUserFunction('Trainer', 'switch')">
              <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Switch User" width="25"
                height="25">
            </a>
          </label>
          <span class="mandatory-symbol">*</span>
        </div>
        <div class="dms-search-container">
          <input id="userName" class="form-control" type="text" placeholder="Trainer"
            [disabled]="!saveButtonForScheduleTraining || !canEditTrainerField()"
            [(ngModel)]="scheduleTrainingFieldData.trainerName" (click)="searchUserFunction('Trainer', 'search')"
            matTooltip="{{ scheduleTrainingFieldData.trainerName }}" matTooltipPosition="above"
            matTooltipDisabled="!scheduleTrainingFieldData.trainerName" />
        </div>
        <span id="userName-required-msg">Please enter an user</span>
      </div>
      <div class="col-md-2">
        <!-- Scheduled Start Date: -->
        <div><label for="email">{{dynamicLabel['SCHEDULED_START_DATE']}}</label><span class="mandatory-symbol">*</span>
        </div>
        <div>
          <input id="scheduleStartDate" type="text" class="form-control data-picker-continer" bsDatepicker
            #datePicker1="bsDatepicker" [bsConfig]="dateTimePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [minDate]="todayDate" [(ngModel)]="scheduleTrainingFieldData.scheduledStartDate"
            (ngModelChange)="setVal($event)" (keydown)="false"
            (ngModelChange)="scheduleTrainingFieldData.scheduledStartDate!=null?onDateChange(datePicker1):''"
            autocomplete="off" [disabled]="disableDateFields()">


        </div>
        <span id="scheduleStartDate-required-msg">Please enter schedule start date</span>
      </div>
      <div class="col-md-2">
        <!-- Scheduled End Date: -->
        <div><label for="email">{{dynamicLabel['SCHEDULED_END_DATE']}}</label><span class="mandatory-symbol">*</span>
        </div>
        <div>
          <input id="scheduleEndDate" type="text" class="form-control data-picker-continer" bsDatepicker
            #datePicker2="bsDatepicker" [bsConfig]="dateTimePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [minDate]="minEndDate"
            (ngModelChange)="scheduleTrainingFieldData.scheduledEndDate!=null?onDateChange(datePicker2):''"
            [(ngModel)]="scheduleTrainingFieldData.scheduledEndDate" (keydown)="false" autocomplete="off"
            [disabled]="disableDateFields()">
        </div>
        <span id="scheduleEndDate-required-msg">Please enter schedule end date</span>
      </div>
      <div class="col-md-2">
        <!-- Status -->
        <div><label for="email">{{dynamicLabel['STATUS']}}</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="scheduleTrainingFieldData.status" disabled>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <!-- Training Mode -->
        <div><label for="email">{{dynamicLabel['TRAINING_MODE']}}</label><span class="mandatory-symbol">*</span></div>
        <mat-select matInput id="trainingMode" placeholder="Select" [(ngModel)]="selectedTrainingMode"
          (closed)="modeSearchText=''" (click)="focusSearch('focus-mode-search')"
          (keydown.enter)="focusSearch('focus-mode-search')" [disabled]="!saveButtonForScheduleTraining">
          <input type="search" id="focus-mode-search" class="dropdownsearchstyle" [(ngModel)]="modeSearchText" matInput
            placeholder="search">
          <mat-option class="unselectStyle" (onSelectionChange)="onModeSelect($event,null)"
            [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of modeDropdown | assessmentSearch : modeSearchText"
            (onSelectionChange)="onModeSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
        <span id="trainingMode-required-msg">Please select training mode</span>
      </div>
      <div class="col-md-2">
        <!-- Actual Start Date: -->
        <div><label for="email">{{dynamicLabel['ACTUAL_START_DATE']}}</label></div>
        <div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker #datePicker3="bsDatepicker"
            [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
            (ngModelChange)="scheduleTrainingFieldData.actualStartDate!=null?onDateChange(datePicker3):''"
            [(ngModel)]="scheduleTrainingFieldData.actualStartDate" (keydown)="false"
            [disabled]="!saveButtonForScheduleTraining" autocomplete="off">
        </div>
      </div>
      <div class="col-md-2">
        <!-- Actual End Date: -->
        <div><label for="email">{{dynamicLabel['ACTUAL_END_DATE']}}</label></div>
        <div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker #datePicker4="bsDatepicker"
            [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
            (ngModelChange)="scheduleTrainingFieldData.actualEndDate!=null?onDateChange(datePicker4):''"
            [(ngModel)]="scheduleTrainingFieldData.actualEndDate" (keydown)="false"
            [disabled]="!saveButtonForScheduleTraining">
        </div>
      </div>
      <div class="col-md-2">
        <!-- Allowed Failed Attempts -->
        <div><label for="email">{{dynamicLabel['ALLOWED_FAILED_ATTEMPTS']}}</label>
          <span matTooltip="The allowed number of assessment attempts before the training is locked(A)"
            matTooltipPosition="above" class="info-icon" style="margin-left: 5px; cursor: pointer;">
            <i class="fas fa-info-circle"></i>
          </span>
        </div>
        <input id="allowedFailedAttempts" class="input-filed-continers" type="number" min="1"
          [(ngModel)]="scheduleTrainingFieldData.allowedFailedAttempts" (keydown)="validateNumberFields($event)"
          [disabled]="!saveButtonForScheduleTraining">
      </div>
      <div class="col-md-2">
        <!-- Failed Attempts After Unlock -->
        <div><label for="email">{{dynamicLabel['ALLOWED_FAILED_ATTEMPTS_AFTER_UNLOCK']}}</label>
          <span matTooltip="The allowed number of re-assessment attempts after being unlocked (B)"
            matTooltipPosition="above" class="info-icon" style="margin-left: 5px; cursor: pointer;">
            <i class="fas fa-info-circle"></i>
          </span>
        </div>
        <input id="allowedFailedAttemptsAfterUnlock" class="input-filed-continers" type="number" min="1"
          [(ngModel)]="scheduleTrainingFieldData.allowedFailedAttemptsAfterUnlock"
          (keydown)="validateNumberFields($event)" [disabled]="!saveButtonForScheduleTraining">
      </div>
      <div class="col-md-2">
        <!-- Max Allowed Failed Attempts -->
        <div><label for="email">{{dynamicLabel['MAX_ALLOWED_FAILED_ATTEMPTS']}}</label><span
            matTooltip="The maximum allowed attempts before the training gets permanently locked(C > A+ B)"
            matTooltipPosition="above" class="info-icon" style="margin-left: 5px; cursor: pointer;">
            <i class="fas fa-info-circle"></i>
          </span></div>
        <input id="maxAllowedFailedAttempts" class="input-filed-continers" type="number" min="1"
          [(ngModel)]="scheduleTrainingFieldData.maxAllowedFailedAttempts" (keydown)="validateNumberFields($event)"
          [disabled]="!saveButtonForScheduleTraining">
      </div>

    </div>
    <div class="row">
      <div class="col-md-10">
        <!-- Training Details -->
        <div><label for="email ">{{dynamicLabel['TRAINING_DETAILS']}}</label></div>
        <div class="hideToolbarForSchedule"><st-editor id="details"
            [(ngModel)]="scheduleTrainingFieldData.trainingDetails" [config]="config"
            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="!isEditorEnabled()"></st-editor></div>
      </div>
      <div class="col-md-2">
        <!-- Training Mode -->
        <div class="row">
          <div class="col-md-11">
            <div><label for="email">Feedback Template</label></div>
            <mat-select matInput placeholder="Select" [(ngModel)]="scheduleTrainingFieldData.feedbackTemplateId"
              (closed)="templateSearchText=''" (click)="focusSearch('focus-template-search')"
              (keydown.enter)="focusSearch('focus-template-search')" [disabled]="!saveButtonForScheduleTraining">
              <input type="search" id="focus-template-search" class="dropdownsearchstyle"
                [(ngModel)]="templateSearchText" matInput placeholder="search">
              <mat-option class="unselectStyle" (onSelectionChange)="onTemplateSelect($event,null)"
                [value]="null">Un-select</mat-option>
              <mat-option *ngFor="let item of feedbackTemplateList | assessmentSearch : templateSearchText"
                (onSelectionChange)="onTemplateSelect($event,item)" [value]="item.templateId">
                {{ item.templateName }}
              </mat-option>
            </mat-select>
          </div>
          <div class="iconsCss col-md-10"
            *ngIf="scheduleTrainingFieldData.feedbackTemplateId!=null && scheduleTrainingFieldData.feedbackFormId"
            (click)="openReportPopup()" (keydown.enter)="openReportPopup()">
            <img alt="img" src="../../assets/img/training_module/report.svg"
              style="width: 25px;margin-top: -70px;margin-left: 190px;" class="iicon" matTooltip="Report">
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10">
        <!-- Location/Information -->
        <div><label for="email ">{{selectedTrainingModeValue}} {{dynamicLabel['TRAINING_MODE_DETAILS']}}</label></div>
        <div class="hideToolbar"><st-editor id="modeDetails" [(ngModel)]="scheduleTrainingFieldData.trainingModeDetails"
            [config]="config" style="min-height: 100px !important;" [spellcheck]="true"
            [disabled]="!saveButtonForScheduleTraining"></st-editor></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2" *ngIf="isShowTrainingAssessmentFlag">
        <!-- Allow User To Take Assessment At Application -->
        <div><label for="email">{{dynamicLabel['ALLOW_USERS_TO_TAKE_ASSESSMENT_AT_APPLICATION']}}</label></div>
        <mat-slide-toggle color="primary"
          [(ngModel)]="scheduleTrainingFieldData.allowUsersToTakeAssessmentAtApplication1"
          [disabled]="!saveButtonForScheduleTraining">
          <span class="active-inActive-container"
            *ngIf="scheduleTrainingFieldData.allowUsersToTakeAssessmentAtApplication1==true"
            [ngStyle]="scheduleTrainingFieldData.allowUsersToTakeAssessmentAtApplication1==true?{'color':'green'} : {'color': ''}">Allow</span>
          <span *ngIf="scheduleTrainingFieldData.allowUsersToTakeAssessmentAtApplication1==false"
            [ngStyle]="scheduleTrainingFieldData.allowUsersToTakeAssessmentAtApplication1==false?{'color':'red'} : {'color': ''}">Don't
            Allow</span>
        </mat-slide-toggle>
      </div>
      <div class="col-md-2">
        <!-- Duration (In Mins) -->
        <div><label for="email">{{dynamicLabel['DURATION_IN_MINS']}}</label></div>
        <input id="maxAttempts" class="input-filed-continers" type="number" min="1"
          [(ngModel)]="scheduleTrainingFieldData.durationInMins" [disabled]="!saveButtonForScheduleTraining">
      </div>
      <div class="col-md-2">
        <!-- Notify Before N Days -->
        <div><label for="email">{{dynamicLabel['NOTIFY_BEFORE_N_DAYS']}}</label></div>
        <input id="notifybeforendays" class="input-filed-continers" type="number" min="1"
          [(ngModel)]="scheduleTrainingFieldData.notifyBeforeNDays" [disabled]="!saveButtonForScheduleTraining">
      </div>

      <div class="col-md-2" *ngIf="scheduleTrainingFieldData.approvalRequestedOn != null">
        <div><label for="email">Approval Requested On:</label></div>
        <div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="scheduleTrainingFieldData.approvalRequestedOn"
            disabled>
        </div>
      </div>

      <div class="col-md-2" *ngIf="scheduleTrainingFieldData.approvedOn != null">
        <!-- Approved On: -->
        <div><label for="email">
            {{ dynamicLabel['APPROVED_ON'] }}
          </label></div>
        <div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="scheduleTrainingFieldData.approvedOn" disabled>
        </div>
      </div>
      <div class="col-md-2" *ngIf="scheduleTrainingFieldData.approvedBy">
        <div><label for="email">Approver:</label>
          <label *ngIf="canShowSwitchUser()" id="owner-validation" for="email"
            (click)="openswitchuser('approver',scheduleTrainingFieldData)"
            (keydown.enter)="openswitchuser('approver',scheduleTrainingFieldData)"><a><img title="Switch User"
                src="..//..//../assets/img/user-switch.png" alt="Yes" width="25" height="25"></a></label>
        </div>
        <div>
          <mat-select matInput placeholder="Select"
            [ngClass]="{'odd-item-mat-select': isOddApprover == message.scheduledTrainingsApprover}"
            [(ngModel)]="message.scheduledTrainingsApprover" (closed)="approverSearchText=''"
            (click)="focusSearch('focus-approver-search')" (keydown.enter)="focusSearch('focus-approver-search')"
            [disabled]="true">
            <input type="search" id="focus-approver-search" class="dropdownsearchstyle" [(ngModel)]="approverSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of approverDropdown | assessmentSearch : approverSearchText"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="col-md-2">
        <div><label for="email">{{dynamicLabel['EXPIRED_ON']}}</label>
        </div>
        <div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="dateTimePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="scheduleTrainingFieldData.expiredOn" (keydown)="false" autocomplete="off" disabled>
        </div>
      </div>
      <div class="col-md-2">
        <div><label for="email">{{dynamicLabel['INITIATED_BY_USER']}}</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="scheduleTrainingFieldData.initiatedByUser"
          disabled>
      </div>
      <div class="col-md-2">
        <div><label for="email">
            {{ dynamicLabel['INITIATED_ON'] }}
          </label></div>
        <div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="scheduleTrainingFieldData.initiatedOn" disabled>
        </div>
      </div>

    </div>
  </div>
</div>
<br>
<br>
<div class="menu-container" *ngIf="scheduleTrainingFieldData.approvedOn != null">
  <div class="row menu-row-container">
    <div class="col-sm-6 gridName-container">
      <span class="gridName">Training Users</span>
    </div>
  </div>

</div>
<div class="d-flex justify-content-between mt-3" *ngIf="scheduleTrainingFieldData.approvedOn != null">
  <div class="d-flex align-items-center px-3"></div>
  <div class="d-flex gap-3">
    <div id="header-container">
      <div class="">
        <div class="search-container">
          <span class="fa fa-search form-control-feedback"></span>
          <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
            [(ngModel)]="searchValue" />
        </div>
      </div>
    </div>
    <div *ngIf="scheduleTrainingFieldData.status == 'Scheduled' && isShowAddUser"
      class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openAddPopupForUser()"
      (keydown.enter)="openAddPopupForUser()">
      <img src="../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Excel')"
      (keydown.enter)="openReport('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Pdf')"
      (keydown.enter)="openReport('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
    <div *ngIf="isShowBulkIcons && scheduleTrainingFieldData.status == 'Scheduled' && isShowIcons"
      class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="performBulkOperation('Delete')" (keydown.enter)="performBulkOperation('Delete')" matTooltip="Delete">
      <i class="fa fa-trash" style="color: white;"></i>
    </div>
    <div *ngIf="isShowBulkIcons && scheduleTrainingFieldData.status == 'Scheduled' && isShowIcons"
      class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="performBulkOperation('Absent')" (keydown.enter)="performBulkOperation('Absent')" matTooltip="Absent">
      <i class="fa fa-ban" style="color: white;"></i>
    </div>
    <div *ngIf="isShowBulkIcons && scheduleTrainingFieldData.status == 'Scheduled' && isShowIcons"
      class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="performBulkOperation('Present')" (keydown.enter)="performBulkOperation('Present')" matTooltip="Present">
      <i class="fa-solid fa-square-check" style="color: white;"></i>
    </div>
  </div>
</div>
<div class="table-container">
  <table class="dynamic-table-container documentTable">
    <th style="width: 60px;left:4px; text-align: center;"
      [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
      <div style="display: flex;">
        <div [ngClass]="parentCheckBoxs?'static_icon':'hover-menu-icons'">
          <i class="fa-solid fa-ellipsis-vertical"></i>
        </div>
        <div>
          <input type="checkbox" style="zoom: 1.2;" [checked]="parentCheckBoxs"
            (change)="dataGridParentCheckBoxChecked($event)">
        </div>
      </div>
    </th>
    <th
      [ngStyle]="{'min-width': '140px', 'max-width': '140px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>User Name</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <th
      [ngStyle]="{'min-width': '240px', 'max-width': '240px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>Full Name</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <th
      [ngStyle]="{'min-width': '240px', 'max-width': '240px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>Status</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <th
      [ngStyle]="{'min-width': '240px', 'max-width': '240px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>Department</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <th *ngIf="scheduleTrainingFieldData.feedbackTemplateId != null"
      [ngStyle]="{'min-width': '240px', 'max-width': '240px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>Feedback Status</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <th *ngIf="scheduleTrainingFieldData.feedbackTemplateId != null"
      [ngStyle]="{'min-width': '200px', 'max-width': '200px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>Feedback Score</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <th *ngIf="scheduleTrainingFieldData.feedbackTemplateId != null"
      [ngStyle]="{'min-width': '240px', 'max-width': '240px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>Feedback Completed On</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <tr>
      <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
      <td [ngStyle]="{ 'min-width': '140px' }" class="sticky-dynamic-col1">
        <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter3('userName', $event)" /> </div>
      </td>
      <td [ngStyle]="{ 'min-width': '240px' }" class="sticky-dynamic-col1">
        <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter3('userFullName', $event)" /> </div>
      </td>
      <td [ngStyle]="{ 'min-width': '240px' }" class="sticky-dynamic-col1">
        <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter3('status', $event)" /> </div>
      </td>
      <td [ngStyle]="{ 'min-width': '240px' }" class="sticky-dynamic-col1">
        <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter3('department', $event)" /> </div>
      </td>
      <td *ngIf="scheduleTrainingFieldData.feedbackTemplateId != null" [ngStyle]="{ 'min-width': '240px' }"
        class="sticky-dynamic-col1">
        <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter3('feedbackStatus', $event)" /> </div>
      </td>
      <td *ngIf="scheduleTrainingFieldData.feedbackScore != null" [ngStyle]="{ 'min-width': '240px' }"
        class="sticky-dynamic-col1">
        <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter3('feedbackScore', $event)" /> </div>
      </td>
      <td *ngIf="scheduleTrainingFieldData.feedbackTemplateId != null" [ngStyle]="{ 'min-width': '240px' }"
        class="sticky-dynamic-col1">
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter3('feedbackCompletedOn', $event)" />
        </div>
      </td>
    </tr>
    <tr *ngFor="let user of pagedItems | searchFilter : searchValue; let idx = index;">
      <td style="width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="user.childCheckBoxs ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="user.childCheckBoxs"
              (change)="dataGridChildCheckBoxChecked($event, user, idx)">
          </div>
        </div>
      </td>
      <td class="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
    white-space: 'nowrap'"><span>{{user.userName}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
     white-space: 'nowrap'"><span>{{user.userFullName}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
      white-space: 'nowrap'"><span>{{user.status}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
      white-space: 'nowrap'"><span>{{user.department}}</span></td>
      <td *ngIf="scheduleTrainingFieldData.feedbackTemplateId != null" class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
      white-space: 'nowrap'"><a href="" (click)="openDetailInPopup($event,user)">{{user.feedbackStatus}}</a></td>
      <td *ngIf="scheduleTrainingFieldData.feedbackTemplateId != null" class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
      white-space: 'nowrap'"><span>{{user.feedbackScore}}</span></td>
     <td id="grid-row-container"
        style="text-align: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
        <span>{{user.feedbackCompletedOn | date: 'dd-MMM-yyyy HH:mm:ss'| uppercase}}</span>
      </td>
      <td class="sticky-col first-col">
        <div class="action-icons">
          <img alt="img" *ngIf="user.feedbackStatus == 'Completed' && isCurrentTrainer()" width="20" height="20"
            src="../../../assets/img/feedback.png" matTooltip="Reinitiate Feedback" style="margin-left: 5px;"
            (click)="ReinitateFeedbackFunc(user)" (keydown.enter)="ReinitateFeedbackFunc(user)" />
        </div>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>

</div>
<div class="d-none table-container" *ngIf="scheduleTrainingFieldData.approvedOn != null">

  <div class="row header-container">
    <div class="col-md-6">
      <div class="row-search-container">
        <input type="text" class="form-control" style="font-size: 13px;" placeholder="Search" [(ngModel)]="searchValue">
      </div>
    </div>
    <div class="col-6 col-md-6pr-0 d-flex  justify-content-end align-items-center">

      {{ showingRowsText }}
      1-{{ perPage }} of {{ collectionSize | number }}
      <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
        [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
        [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
      </ngb-pagination>
      <div ngbDropdown class="d-inline-block leftpadding">
        <button class="btn btn-primary btn-sm mr-1 dropdownBasic1" ngbDropdownToggle>
          {{perPage}}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button ngbDropdownItem (click)="paginationCall(5)">5</button>
        </div>
        per page
      </div>
    </div>
  </div>
  <table class="dynamic-table-container">
    <th style="min-width: 60px; text-align: center;"
      [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
      <div style="display: flex;">
        <div>
          <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
        </div>
        <div>
          <input type="checkbox" style="zoom: 1.2;" [checked]="parentCheckBox"
            (change)="dataGridParentCheckBoxChecked($event)">
        </div>
      </div>
    </th>
    <th style="width: 80px; text-align: center;overflow: hidden;text-overflow: 'ellipsis';
    white-space: 'nowrap'"> <span> User Name</span> <span class="fa-solid fa-filter grid-header-container"></span>
    </th>
    <th style="width: 240px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
    white-space: 'nowrap'"> <span>Full Name</span> <span class="fa-solid fa-filter grid-header-container"></span>
    </th>
    <th style="width: 280px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
    white-space: 'nowrap'"> <span>Status</span> <span class="fa-solid fa-filter grid-header-container"></span>
    </th>

    <tr *ngFor="let user of scheduleUsersList | searchFilter : searchValue; let idx = index;">
      <td style="width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="user.childCheckBoxs ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
              (change)="dataGridChildCheckBoxChecked($event, user, idx)">
          </div>
        </div>
      </td>
      <td class="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
      white-space: 'nowrap'"><span>{{user.userName}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
       white-space: 'nowrap'"><span>{{user.userFullName}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"><span>{{user.status}}</span></td>

    </tr>
  </table>
</div>
<ng-template #searchUser>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchUserFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div id="filed-container" class="form-continer">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name"
          [(ngModel)]="searchByUserName">
        <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter First Name"
          [(ngModel)]="searchByFirstName">
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Last Name" [(ngModel)]="searchByLastName">
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode"
          (closed)="designationSearchText=''" (click)="focusSearch('focus-designation-search')"
          (keydown.enter)="focusSearch('focus-designation-search')">
          <input type="search" id="focus-designation-search" class="dropdownsearchstyle"
            [(ngModel)]="designationSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" (onSelectionChange)="onDesignationCodeSelect($event,null)"
            [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of designationCodeDropdown | assessmentSearch : designationSearchText"
            (onSelectionChange)="onDesignationCodeSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

    </div>
    <div class="row">
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')"
          (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" (onSelectionChange)="onDepartmentCodeSelect($event,null)"
            [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : departmentSearchText"
            (onSelectionChange)="onDepartmentCodeSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row fieldstyle">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchUserGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchUserGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container" style="height: 50vh;">
        <thead>
          <th style="min-width: 80px; text-align: center;">
            <div style="display: flex;" *ngIf="searchVal != 'Trainer'">
              <div>
                <i class="fa-solid fa-ellipsis-vertical parent-menu-icons"></i>
              </div>
              <div style="margin-left: 5px;">
                <input type="checkbox" style="zoom: 1.2;" [checked]="searchUserParentCheckBox"
                  (change)="searchUserDataGridParentCheckBoxChecked($event)">
              </div>
            </div>
          </th>
          <th> <span>User Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
          <th> <span>First Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
          <th> <span>Last Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
          <th> <span>User Full Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
          <th> <span>Designation</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
          <th> <span>Department</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
          <th> <span>EmailAddress</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
          <th> <span>Manager Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
          <th id="menu" class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <tr class="data-row-container"
            *ngFor="let listOfUsersVwDetails of getOneQmsUsersVwDetailsTableData; let idx = index;">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="listOfUsersVwDetails.searchUserChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2;"
                    [checked]="listOfUsersVwDetails.searchUserChildCheckBoxs"
                    (change)="searchUserChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ listOfUsersVwDetails.userName }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.firstName }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.lastName }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.userFullname }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.designation }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.department }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.emailAddress }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.managerName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addUserNameFunction()"
      (keydown.enter)="addUserNameFunction()" *ngIf="searchMode == 'search'">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="switchTrainerName()"
      (keydown.enter)="switchTrainerName()" *ngIf="searchMode == 'switch'">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add & Save</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchUserFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #operationPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelPerformFunc()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="pop" class="popupTitle"> {{buttonValue}}</label>
      <label for="pop" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer filed-container" style="height: auto !important;">
      <div class="row" *ngIf="buttonValue == 'Submit for Approval'">
        <div class="col-md-3"><label id="approver-label" for="questionType">Approver</label><span
            class="mandatory-symbol">*</span></div>
        <div class="col-md-9">
          <mat-select matInput placeholder="Select" [(ngModel)]="message.scheduledTrainingsApprover"
            (closed)="approverSearchText=''" (click)="focusSearch('focus-approver-search')"
            (keydown.enter)="focusSearch('focus-approver-search')">
            <input type="search" id="focus-search" class="dropdownsearchstyle" [(ngModel)]="approverSearchText" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of approverDropdown | assessmentSearch : approverSearchText"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <span id="approver-required-msg" style="margin-left:25%;">Please select approver</span>
      </div>
      <div class="row" *ngIf="buttonValue != 'Submit for Approval' && buttonValue != 'Mark As Completed'"
        style="margin-left: 5%;">
        <span
          *ngIf="(buttonValue == 'Initiate Assessment' || buttonValue == 'Intimate Trainees') && (scheduleTrainingFieldData.feedbackTemplateId==null || scheduleTrainingFieldData.feedbackTemplateId=='')"><b>NOTE
            :</b> Please make sure, Feedback is required or not because once assessment initiated feedback cannot be
          initiate again. </span>
        <div class="col-md-12">
          <div><label for="email">Comments</label><span class="mandatory-symbol">*</span></div>
          <textarea id="commentsForOpern" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="comments"></textarea>
          <span id="commentsForOpern-required-msg">Please provide the comments</span>
        </div>

      </div>
      <div class="row" *ngIf="buttonValue == 'Mark As Completed'">
        <div class="col-md-3"><label for="questionType">{{dynamicLabel['ACTUAL_START_DATE']}}</label><span
            class="mandatory-symbol">*</span>
          : </div>
        <div class="col-md-9">
          <input id="actualStartDate" type="text" class="form-control data-picker-continer" bsDatepicker
            #datePicker5="bsDatepicker" [bsConfig]="dateTimePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [maxDate]="todayDate" [(ngModel)]="actualStartDate" (keydown)="false"
            (ngModelChange)="actualStartDate!=null?onDateChange(datePicker5):''" autocomplete="off">
        </div>
        <span id="actualStartDate-required-msg" style="margin-left:25%;">Please enter start date</span>
      </div>
      <br>
      <div class="row" *ngIf="buttonValue == 'Mark As Completed'">
        <div class="col-md-3"><label for="questionType">{{dynamicLabel['ACTUAL_END_DATE']}}</label><span
            class="mandatory-symbol">*</span> :
        </div>
        <div class="col-md-9">
          <input id="actualEndDate" type="text" class="form-control data-picker-continer" bsDatepicker
            #datePicker6="bsDatepicker" [bsConfig]="dateTimePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [minDate]="actualStartDate" [maxDate]="todayDate" [(ngModel)]="actualEndDate" (keydown)="false"
            autocomplete="off" (ngModelChange)="actualEndDate!=null?onDateChange(datePicker6):''">
        </div>
        <span id="actualEndDate-required-msg" style="margin-left:25%;">Please enter end date</span>
      </div>
      <br>
      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="performOperationFunc()" (keydown.enter)="performOperationFunc()">
          <span class="reload_text text-white">{{buttonValue}}</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="cancelPerformFunc()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #confirmPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelConfirmFunc()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="pop" class="popupTitle"> {{buttonValue}}</label>
      <label for="pop" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer filed-container" style="height: auto !important;">
      <div class="row">
        <div class="col-md-3"><label for="username ">User Name</label><span class="mandatory-symbol">*</span>
        </div>
        <div class="col-md-9"> <input id="username" style="height: 80% !important;" class="input-filed-continers"
            type="text" [(ngModel)]="displayUserName" disabled>
        </div>
      </div>
      <div class="row" *ngIf="(!isAdenabled)">
        <div class="col-md-3"><label for="pass ">Password</label><span class="mandatory-symbol">*</span></div>
        <div class="col-md-9"> <input id="password" style="height: 80% !important;" class="input-filed-continers"
            [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste>
          <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()"
            noCopyPaste>
            <i
              [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
          </span>
        </div>
        <span style="margin-left: 25%;" id="password-required-msg">Please enter password</span>
      </div>
      <div class="row">
        <div class="col-md-3"><label for="questionType">Comments</label><span class="mandatory-symbol">*</span></div>
        <div class="col-md-9">
          <textarea id="comments" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="comments"></textarea>
          <span id="comments-required-msg">Please provide the comments</span>
        </div>
      </div>


      <br>

      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="confirmFunc()"
          (keydown.enter)="confirmFunc()">
          <span class="reload_text text-white">{{buttonValue}}</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="cancelConfirmFunc()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">Add Instructor Users</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container1" class="form-continer">
      <div class="row">
        <div class="col-md-12" class="search-container">
          <div><label for="email ">User</label><span class="mandatory-symbol">*</span></div>
          <span class="fa fa-search form-control-feedback" (click)="searchUserFunction('User','search')"
            (keydown.enter)="searchUserFunction('User','search')"></span>
          <input id="userNameForInstructor" class="form-control" type="text" placeholder="Search"
            [(ngModel)]="userNameList" disabled>
          <span id="userNameForInstructor-required-msg">Please search an user</span>
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addAndEditFunction()">
      <i class="fas fa-plus"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #bulkOperationPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelPerformBulkFunc()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="pop" class="popupTitle"> Confirmation</label>
      <label for="pop" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer filed-container" style="height: auto !important;">

      <div class="row" style="margin-left: 8%;">
        <div>Are you sure, you want to mark the user as {{bulkOperationValue}}?</div><br>
        <div style="width:350px;word-wrap: break-word;">Users : {{userNameListForBulkOperation}}</div>
      </div>

      <br>

      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="performBulkOperationFunc()" (keydown.enter)="performBulkOperationFunc()">
          <span class="reload_text text-white">OK</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="cancelPerformBulkFunc()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #initiateFeedbackPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelInitiateFeedbackFunc()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="pop" class="popupTitle"> {{buttonValue}}</label>
      <label for="pop" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer filed-container" style="height: auto !important;">

      <div class="row">
        <div class="col-md-3">
          <label for="pass">Expiry On</label>
          <span class="mandatory-symbol">*</span>
        </div>
        <div class="col-md-9">
          <input id="feedbackExpiryDate" type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="dateTimePickerConfigurationForExpired" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="expiredOn" (keydown)="false"
             (bsValueChange)="onExpiryDateChange($event)">
        </div>
        <span style="margin-left: 25%; display: none; color: red;" id="feedbackExpiryDate-required-msg">
          Please enter expiry date
        </span>
      </div>
      <br>
      <div class="row">
        <div class="col-md-3"><label for="questionType">Comments</label><span class="mandatory-symbol">*</span></div>
        <div class="col-md-9">
          <textarea id="comments" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="comments"></textarea>
          <span id="comments-required-msg">Please provide the comments</span>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="confirmInitiateFeedbackFunc()" (keydown.enter)="confirmInitiateFeedbackFunc()">
          <span class="reload_text text-white">{{buttonValue}}</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="cancelInitiateFeedbackFunc()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #feedbackDetailPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelFeedbackFunc()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Feedback Details</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="max-height:500px;overflow-y: auto;overflow-x: hidden;">
    <div class="row">

    </div>
    <div class="row" style="margin-top: 10px;">
      <div class="col-md-12">
        <div class="row" *ngFor="let field of feedbackQuestionsList,let i=index;">
          <div class="row" style="margin-bottom:10px;">
            <div class="col-md-6"><label for="name">{{field.questionCode}}.{{field.question}}</label></div>
            <div class="col-md-5" *ngIf="field.fieldTypeCode =='Text Field'">
              <input attr.id="field{{i}}" class="input-filed-continers" type="text" [(ngModel)]="field.fieldValue"
                disabled>
            </div>
            <div class="col-md-5" *ngIf="field.fieldTypeCode =='Large Text Field'">
              <textarea attr.id="field{{i}}" type="text" class="input-filed-textarea" rows="4"
                [(ngModel)]="field.fieldValue" disabled></textarea>
            </div>

            <div class="col-md-5" *ngIf="field.fieldTypeCode =='Drop Down'">
              <mat-select matInput placeholder="Select" [(ngModel)]="field.fieldValue" (closed)="fieldsSearchTxt=''"
                (click)="focusmethod('focusSearch')" (keydown.enter)="focusmethod('focusSearch')" disabled>
                <input type="search" attr.id="field{{i}}" class="dropdownsearchstyle" [(ngModel)]="fieldsSearchTxt"
                  matInput placeholder="Search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onFlexifieldSelect(field,null);">Un-select</mat-option>
                <mat-option *ngFor="let item of field.dropDownValues| assessmentSearch :fieldsSearchTxt"
                  (onSelectionChange)="onFlexifieldSelect(field,item)" [value]="item">
                  {{ item }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-5" *ngIf="field.fieldTypeCode =='Radio Button'">
              <mat-radio-group attr.id="field{{i}}" [(ngModel)]="field.fieldValue" disabled>
                <mat-radio-button *ngFor="let val of field.dropDownValues" [value]="val"
                  (change)="radioBoxChecked(field,$event,val)">{{val}}</mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col-md-1">
              <div>{{field.fieldScore}}</div>
            </div>
          </div>
          <br>
        </div>
      </div>

    </div>
  </div>

  <div style="margin: 5px 0px;">
    <div class="button-continer btn-align" mat-dialog-actions>

      <button mat-stroked-button class="cancelButton" (click)="cancelFeedbackFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #reportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Feedback User Question Report</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
  </div>&nbsp;&nbsp;&nbsp;

  <div class="row">
    <!-- Average Question Score Table - Full width when individualReport is false, half when true -->
    <div class="table-container" [class.col-md-11]="!individualReport" [class.col-md-6]="individualReport">
      <div class="row" *ngIf="avgFinalScroe">
        <br />
        <div class="col-md-6">
          <div class="mini-chart-container1 backGroundColor hover-shadow">
            <div class="d-flex gap-2">
              &nbsp;
              <div class="d-flex justify-content-center align-items-center requests_menu">
                <img src="../../../assets/img/cr_module/total_requests.svg" width="16px" height="16px"
                  alt="Avg Final Score" />
              </div>
              <div class="d-flex flex-column">
                <span class="chart-count" style="margin: bottom 5px; margin: top 5px;">{{ avgFinalScroe }}</span>
                <span class="d-flex px-1">
                  <span class="chart-text me-2">Avg Final Score</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-4" style="font-weight: bold; font-size: 0.8rem; margin-top:20px">Average Question Score</div>
        <div class="col-4"></div>
        <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openExcelPdfReportPopup('Excel','1')" (keydown.enter)="openExcelPdfReportPopup('Excel','1')">
          <i class="fa fa-file-excel-o" style="font-size: 0.5rem; color:white"></i>
          <span class="reload_text text-white" style="font-size: 0.5rem;">Excel Report</span>
        </div>
        <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openExcelPdfReportPopup('Pdf','1')" (keydown.enter)="openExcelPdfReportPopup('Pdf','1')">
          <i class="fa fa-file-pdf-o" style="font-size: 0.5rem;color:white"></i>
          <span class="reload_text text-white" style="font-size: 0.5rem;">PDF Report</span>
        </div>
      </div>
      &nbsp;&nbsp;
      <div class="table-container">
        <table style="height: 60vh;">
          <thead style="z-index:9">
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Question Code</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter('questionCode', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style" style="width: 500px;">
              <span>Question</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter('question', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Possible Score</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter('possibleScore', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Feedback User Count</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter('feedbackUserCnt', $event,'n')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Avg Field Score</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter('avgFieldScore', $event,'s')" />
              </div>
            </th>
            <th class="menu sticky-col first-col"></th>
          </thead>
          <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems2; let idx = index;">
            <td class="row-data default-style" (click)="openInduReportPopup(idx, listOfUsersData)"
              (keydown.enter)="openInduReportPopup(idx, listOfUsersData)">
              {{ listOfUsersData.questionCode }}
            </td>
            <td class="row-data">{{ listOfUsersData.question }}</td>
            <td class="row-data">{{ listOfUsersData.possibleScore }}</td>
            <td class="row-data">{{ listOfUsersData.feedbackUserCnt }}</td>
            <td class="row-data">{{ listOfUsersData.avgFieldScore }}</td>
          </tr>
        </table>
      </div>
      <div class="row border-top mt-1 width-cheat small paginationCell">
        <nav class="col-4 col-md-2 mt-2" aria-labelledby=" "></nav>
        <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
          <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
          <div ngbDropdown class="d-inline-block leftpadding">
            <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic4" ngbDropdownToggle>
              {{perPage}}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
              <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
            </div>
            per page
          </div>
        </nav>
        <div class="col-2 col-md-4 d-flex justify-content-end align-items-center"></div>
      </div>
    </div>

    <!-- Individual Score Table - Only shown when individualReport is true -->
    <div class="table-container col-md-5" *ngIf="individualReport">
      <div class="row">
        <div class="col-4" style="padding: 22px 10px;"></div>
      </div>
      <div class="row">
        <div class="col-4" style="font-weight: bold; font-size: 0.8rem; margin-top:20px">Individual Score</div>
        <div class="col-4"></div>
        <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openExcelPdfReportPopup('Excel','2')" (keydown.enter)="openExcelPdfReportPopup('Excel','2')">
          <i class="fa fa-file-excel-o" style="font-size: 0.5rem;color:white"></i>
          <span class="reload_text text-white" style="font-size: 0.5rem;">Excel Report</span>
        </div>
        <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openExcelPdfReportPopup('Pdf','2')" (keydown.enter)="openExcelPdfReportPopup('Pdf','2')">
          <i class="fa fa-file-pdf-o" style="font-size: 0.5rem;color:white"></i>
          <span class="reload_text text-white" style="font-size: 0.5rem;">PDF Report</span>
        </div>
      </div>
      &nbsp;&nbsp;
      <div class="table-container">
        <table style="height: 60vh;">
          <thead style="z-index:4">
            <th class="sticky-dynamic-col1 dynamic-table-header-style" style="width:100px;">
              <span>Question Code</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('questionCode', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style" style="width:500px;">
              <span>Question</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('question', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Possible Options</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('possibleOptions', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Possible Score</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('possibleScore', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>User Name</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('userName', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Field Value</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('fieldValue', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Field Score</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('fieldScore', $event,'s')" />
              </div>
            </th>
            <th class="sticky-col first-col menu"></th>
          </thead>
          <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
            <td class="row-data">{{ listOfUsersData.questionCode }}</td>
            <td class="row-data">{{ listOfUsersData.question }}</td>
            <td class="row-data">{{ listOfUsersData.possibleOptions }}</td>
            <td class="row-data">{{ listOfUsersData.possibleScore }}</td>
            <td class="row-data">{{ listOfUsersData.userName }}</td>
            <td class="row-data">{{ listOfUsersData.fieldValue }}</td>
            <td class="row-data">{{ listOfUsersData.fieldScore }}</td>
          </tr>
        </table>
      </div>
      <div class="row border-top mt-1 width-cheat small paginationCell">
        <nav class="col-4 col-md-2 mt-2" aria-labelledby=" "></nav>
        <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
          <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
          <div ngbDropdown class="d-inline-block leftpadding">
            <button class="btn btn-primary btn-sm mr-1 dropdownBasic4" ngbDropdownToggle>
              {{perPage}}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
              <button ngbDropdownItem (click)="paginationCall2(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall2(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall2(50)">50</button>
            </div>
            per page
          </div>
        </nav>
        <div class="col-2 col-md-4 d-flex justify-content-end align-items-center"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #individualReportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelIndividualReportPopupFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Feedback User Question Report</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="table-container">
    <div class="row">
      <div class="col-4" style="font-weight: bold;  font-size: 2rem; ">Individual Score</div>
      <div class="col-4"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openExcelPdfReportPopup('Excel','2')" (keydown.enter)="openExcelPdfReportPopup('Excel','2')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openExcelPdfReportPopup('Pdf','2')" (keydown.enter)="openExcelPdfReportPopup('Pdf','2')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Question Code</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('questionCode', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" style="width:500px;">
            <span>Question</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('question', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Possible Options</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('possibleOptions', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Possible Score</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('possibleScore', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>User Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('userName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Field Value</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('fieldValue', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Field Score</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('fieldScore', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col menu"></th>
        </thead>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
          <td class="row-data">{{ listOfUsersData.questionCode }}</td>
          <td class="row-data">{{ listOfUsersData.question }}</td>
          <td class="row-data">{{ listOfUsersData.possibleOptions }}</td>
          <td class="row-data">{{ listOfUsersData.possibleScore }}</td>
          <td class="row-data">{{ listOfUsersData.userName }}</td>
          <td class="row-data">{{ listOfUsersData.fieldValue }}</td>
          <td class="row-data">{{ listOfUsersData.fieldScore }}</td>

        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 dropdownBasic4" ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
            <button ngbDropdownItem (click)="paginationCall2(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall2(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall2(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
</ng-template>

<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel && typeVals!='3'">
    <label for="email" style="font-size: .7rem; font-weight: bold;">
      <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
      <span *ngIf="manuallyPicked && maxCountReached">
        We recommend selecting a maximum of 10 columns for a cleaner and more readable PDF
      </span>
    </label>
  </div>
  <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
    <div class="col-md-12" *ngIf="selectedColumns.length && this.typeVals!='3'">
      <div><label for="email">Selected Column(s)</label></div>
      <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
        rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
    </div>
    <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
      <div class="col-md-6">
        <label for="radio">PDF Page Size</label>
        <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
          <mat-radio-button *ngFor="let data of pdfPageSizes"
            [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-md-6" style="margin-top: 1.5%;" *ngIf="this.typeVals!='3'">
        <label for="toggle">Pick Columns Manually?</label>&nbsp;
        <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked" id="toggle">
          <ng-container *ngIf="manuallyPicked; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row mt-3" *ngIf="manuallyPicked && typeVals!='3'">
      <div class="col-md-12">
        <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
        <mat-select matInput multiple placeholder="Select" #pdf [(ngModel)]="selectedColumns"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')"
          (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-dep-search" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText"
            matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="pdfColumnSelection" (change)="toggleAllSelection1('pdf')"> Select
              All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : departmentSearchText"
            [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
            {{item.displayExp}}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter" (closed)="pdfDetailSearchText=''"
          (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-footer-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">

          <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>

    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label id="reportLogo-validation" for="email">Is Save Report?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
          <ng-container *ngIf="isSaveReport; else noisSaveReport">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noisSaveReport>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="isSaveReport">
      <div class="col-sm-4">
        <label id="reportLogo-validation" for="email">Report Name</label>
      </div>
      <div class="col-sm-8">
        <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button *ngIf="isForExcel && typeVals!='3'" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel && typeVals!='3'" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel && typeVals=='3'" mat-stroked-button class="addButton"
      (click)="openReportPopupAttanace('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #reInitiateFeedbackPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReinitiateFeedbackFunc()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="pop" class="popupTitle"> Confirmation</label>
      <label for="pop" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer filed-container" style="height: auto !important;">
      <div class="row" style="margin-left: 8%;">
        <div>Are you sure, you want to re-initiate feedback?</div><br>
      </div>
      <br>
      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="performReinitiateFunc()" (keydown.enter)="performReinitiateFunc()">
          <span class="reload_text text-white">OK</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="cancelReinitiateFeedbackFunc()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #extendFeedbackPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelExtendFeedbackFunc()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="pop" class="popupTitle"> {{buttonValue}}</label>
      <label for="pop" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container" class="form-continer" style="height: auto !important;">

      <div class="row">
        <div class="col-md-3"><label for="extendDate">New Expiry Date</label><span class="mandatory-symbol">*</span>
        </div>
        <div class="col-md-9">
          <input id="extendDate" type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="dateTimePickerConfigurationForExpired" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="extendFeedbackExpiredOn" (keydown)="false">
        </div>
        <span id="extendDate-required-msg" style="display:none; color:red; margin-left: 25%;">Please select a
          date</span>
      </div>
      <br>
      <div class="row">
        <div class="col-md-3"><label for="comments">Comments</label><span class="mandatory-symbol">*</span></div>
        <div class="col-md-9">
          <textarea id="extendComments" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="comments"></textarea>
          <span id="extendComments-required-msg" style="display:none; color:red;">Please provide comments</span>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="confirmExtendFeedbackFunc()" (keydown.enter)="confirmExtendFeedbackFunc()">
          <span class="reload_text text-white">Save</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="cancelExtendFeedbackFunc()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>

<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>